import React from 'react'
import './style.scss'

export default function ActionsBox({
  onEditEvent,
  onBroadcast,
  onCloseOrder,
  onExportOrders,
  onAddEventCost,
  eventCost,
  isClosed = false,
  isByAdmin = false,
  style,
}) {
  const adminStyle = isByAdmin
    ? { opacity: 0.6, pointerEvents: 'none', cursor: 'not-allowed' }
    : {}

  return (
    <div className="od-actions" style={style}>
      <button className="btn secondary" style={adminStyle} onClick={onEditEvent}>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
        </svg>
        Edit Event
      </button>

      <button className="btn secondary" style={adminStyle} onClick={onBroadcast}>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3 11l18-8-8 18-2-8-8-2z" />
        </svg>
        Broadcast
      </button>

      <button className="btn secondary" style={adminStyle} onClick={onCloseOrder}>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="3" y="11" width="18" height="11" rx="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
        {isClosed ? 'Re-open' : 'Close Order'}
      </button>

      <button className="btn secondary" style={adminStyle} onClick={onExportOrders}>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="7 10 12 15 17 10" />
          <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
        Export Orders
      </button>

      <button className="btn secondary" id="od-cost-btn" style={adminStyle} onClick={onAddEventCost}>
        <svg
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="12" y1="1" x2="12" y2="23" />
          <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
        </svg>
        {Number(eventCost) > 0 ? `Event Cost: $${Number(eventCost).toFixed(2)}` : 'Add Event Cost'}
      </button>
    </div>
  )
}
